import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const stagger = {
  animate: {
    transition: { staggerChildren: 0.1 },
  },
};

const HeroHome: React.FC = () => {
  return (
    <>
      <section className="pt-12 sm:pt-16 md:pt-24 pb-12 sm:pb-16">
        <motion.div
          className="container mx-auto px-4 sm:px-6 lg:px-8"
          variants={stagger}
          initial="initial"
          animate="animate"
        >
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="flex flex-col justify-center text-center lg:min-h-[400px]">
              <motion.h1
                className="font-manrope text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-tight"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                Matterport to
                <br />
                <span className="text-[#3C59B2]">
                  Video Service
                </span>
              </motion.h1>

              <motion.p
                className="font-manrope mt-6 sm:mt-8 md:mt-10 text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 font-medium leading-relaxed px-2 sm:px-0"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <span className="block">Send your Matterport links. Get videos.</span>
              </motion.p>

              <motion.div
                className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-8 sm:mt-10 md:mt-12 justify-center items-center px-4 sm:px-0"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <a
                  href="/signup?section=try-one"
                  className="btn-premium w-full sm:w-[200px] md:w-[220px] lg:w-[240px] h-[48px] sm:h-[52px] md:h-[56px] bg-white text-[#3C59B2] border-2 border-[#3C59B2] rounded-full overflow-hidden font-bold text-sm sm:text-base md:text-lg hover:bg-slate-50 transition-all flex items-center justify-center"
                >
                  Try One Property
                </a>
                <a
                  href="/signup"
                  className="btn-premium w-full sm:w-[220px] md:w-[240px] lg:w-[260px] h-[48px] sm:h-[52px] md:h-[56px] bg-[#3C59B2] text-white rounded-full overflow-hidden font-bold text-sm sm:text-base md:text-lg hover:bg-[#2d4a8f] transition-all flex items-center justify-center gap-2"
                >
                  Get Started Now <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
                </a>
              </motion.div>

              <motion.p
                className="mt-4 text-sm text-gray-500"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                Are you a Matterport photographer?{' '}
                <a href="/partners" className="text-[#3C59B2] font-semibold hover:underline">
                  See our partner program →
                </a>
              </motion.p>
            </div>

            <motion.div
              className="lg:pl-8 mt-8 lg:mt-0"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="relative">
                <div className="rounded-2xl overflow-hidden shadow-lg">
                  <video
                    className="w-full"
                    controls
                    playsInline
                    preload="metadata"
                    poster="https://pub-856ba7aa61aa48e7a455614a46820b28.r2.dev/image%20cle%CC%81.webp"
                  >
                    <source src="https://pub-856ba7aa61aa48e7a455614a46820b28.r2.dev/Why%20is%203DtoVideo.com%20A%20Good%20Solution%20and%20Who%20Are%20the%20Appropriate%20Customers.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </section>
    </>
  );
};

export default HeroHome;

